<template>
  <div>
    <b-row class="toolbar-ptc">
      <b-col></b-col>
      <b-col class="text-center title">情報分析 / 第三方支付訂單查詢</b-col>
      <b-col>
        <div class="text-right">
          <b-btn class="btn btn-ptc1" v-b-toggle.collapse1>查詢</b-btn>
        </div>
      </b-col>
    </b-row>

    <div id="func-content">
      <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;" visible>
        <b-card class="bg-default-card">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-4 box-shadow">
                <div class="row">
                  <div class="row col-md-10 mt-3">
                    <div class="row col-md-12">
                      <label class="control-label col-md-2">品牌：</label>
                      <div class="col-md-4">
                        <select
                          name="queryBrandsCode"
                          class="form-control"
                          v-model="search.queryBrandsCode"
                        >
                        <option
                          v-for="x in selectListBrands"
                          v-bind:value="x.Code"
                          :key="x.Code"
                        >{{x.Text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row col-md-12 mt-3">
                      <label class="control-label col-md-2 mt-2">門市：</label>
                      <div class="col-md-4">
                        <multiselect v-model="search.store" :options="storeList" :multiple="false" :custom-label="nameWithLang" placeholder="請輸入關鍵字搜尋" track-by="Name" label="Name" selectLabel="">
                          <span slot="noResult">查無資料</span>
                        </multiselect>
                        <!-- <select id="store" name="store" class="form-control" v-model="search.store">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in storeList" v-bind:value="x.ID" :key="x.ID">{{x.Name}}</option>
                        </select> -->
                      </div>
                      <label class="control-label col-md-2 mt-2">支付工具：</label>
                      <div class="col-md-4">
                        <select id="payment" name="payment" class="form-control" v-model="search.payment">
                          <option v-bind:value="0" :key="0">全部</option>
                          <option v-for="x in paymenttypeList" v-bind:value="x.ID" :key="x.ID">{{x.Text}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="row col-md-12 mt-2">
                      <label class="control-label col-md-2 mt-2">月份區間：</label>
                      <div class="col-md-3">
                        <input type="text" class="form-control" v-model="search.sdate">
                      </div>
                      <div class="mt-2">至</div>
                      <div class="col-md-3">
                        <input type="text" class="form-control" v-model="search.edate">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 mt-3 text-right">
                    <button type="button" class="btn btn-ptc1" @click="btnQuery">查詢</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-collapse>
      <b-card class="bg-default-card">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-6">
                <h3></h3>
              </div>
              <div class="col-lg-12 mt-2">
                <div class="table-responsive">
                  <table class="table table-bordred table-striped">
                    <thead>
                      <tr>
                        <th>項次</th>
                        <th>月份</th>
                        <th>門市</th>
                        <th>訂餐總數</th>
                        <th>正常交易數</th>
                        <th>訂單取消/退款數</th>
                        <th>總金額</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(x,index) in items" :key="x.Code">
                        <td>{{index + 1}}</td>
                        <td>{{x.Month}}</td>
                        <td>{{x.StoreName}}</td>
                        <td>{{x.TotalCount}}</td>
                        <td>{{x.SucceedCount}}</td>
                        <td>{{x.ReCount}}</td>
                        <td>{{x.Total}}</td>
                        <td>
                          <router-link v-b-tooltip.hover.top title="明細" class="btn-circle btn-circle-ptc1" tag="button" :to="{ name: 'information_payment_itemlist', params: { month: x.Month, storeid: x.StoreID, storename: x.StoreName, total:x.Total, search:search } }"><span class="fa fa-search-plus"></span></router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row" style="padding: 0 1rem">
                  <b-pagination size="md" :total-rows="search.totalrows" v-model="search.currentPage" :per-page="search.perpage" @change="changePage"></b-pagination>
                  <label style="margin:8px">{{search.startRowNum}}到{{search.endRowNum}}，總共 {{search.totalrows}}筆</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script src="//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js"></script>
<script src="//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js"></script>

<script>
import { getFunctionPermission } from "../../../js/LoginUserFunction.js";
import { API_URL } from "../../../store/root";
import miniToastr from "mini-toastr";
import draggable from "vuedraggable";
import VModal from "vue-js-modal";
import axios from "axios";
import Multiselect from 'vue-multiselect'

miniToastr.init();
export default {
  components: {
    draggable, Multiselect
  },
  data() {
    return {
      search: {
        store: '',
        payment: 0,
        sdate: "",
        edate: "",
        currentPage: 1,
        perpage: 20,
        totalrows: 0,
        startRowNum: 0,
        endRowNum: 0,
        queryBrandsCode: "MWD",
      },
      storeList: [],
      paymenttypeList: [], // 付款類型
      API_URL: API_URL,
      selectListPosType: [], // Pos分類下拉選單
      startRowNum: 0,
      endRowNum: 0,
      items: [],
      md_imgUrl: undefined,
      selectListBrands: [], // 品牌下拉選單
    };
  },
  created() {
    this.FunctionPermission = getFunctionPermission("F23"); // 功能權限
    if (this.FunctionPermission < 1) {
      this.$router.push({ name: "name" });
      return;
    }
    this.setdate();
    this.getpost();
    this.querySelectListData();

    var search = this.$route.params.search;
    if (search !== undefined) {
      this.search = search
    }
    this.query();
    this.querySelectListBrands();
  },
  methods: {
    btnQuery() {
      this.search.currentPage = 1;
      this.query();
    },
    CheckDateTime(mystring) {
      var reg = /^(\d{4})\/(\d{2})$/;
      var str = mystring;
      var arr = reg.exec(str);
      if (str=="") return true;
      if (!reg.test(str)&&RegExp.$2<=12&&RegExp.$3<=31){
        return false;
      }
      return true;
    },
    getpost () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/marketing/getallstores/v1', {
        brandCode: this.search.queryBrandsCode
      })
        .then((response) => {
          if (response.data.result === '0000') {
            var storeList = this.storeList;
            var list = response.data.data
            list.forEach(function (arrRole, Index) {
              arrRole.Districts.forEach(function (arrRole1, Index1) {
                if (arrRole1.District === "全部區域") {
                  arrRole1.Stores.forEach(function (arrRole2, Index2) {
                    storeList.push(arrRole2);
                  })
                }
              })
            })
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    query () {
      var name, attributesCode, status, appShow, payment, sdate, edate, page, pageRows;
      status = 1;
      payment = this.search.payment;
      pageRows = this.pageRows;
      if (!this.CheckDateTime(this.search.sdate)){
        miniToastr.error("起始日期格式錯誤");
        return
      }
      if (!this.CheckDateTime(this.search.edate)){
        miniToastr.error("結束日期格式錯誤");
        return
      }
      if (this.search.sdate > this.search.edate){
        miniToastr.error("起始月份不可大於結束月份");
        return
      }
      this.$parent.Loading = true;
      var store = 0;
      if (this.search.store) {
        store = this.search.store.ID;
      }
      return axios
        .post(API_URL + "/web/information/payment/v1", {
          sdate: this.search.sdate,
          edate: this.search.edate,
          store: store,
          payment: this.search.payment,
          toPage: this.search.currentPage,
          perPage: this.search.perpage,
          brandCode: this.search.queryBrandsCode,
        })
        .then(response => {
          this.$store.commit("TOKEN", response.data.jwt);
          this.$parent.Loading = false;

          if (response.data.result === "0000") {
            this.items = response.data.data;
            this.search.totalrows = (response.data.count === undefined) ? 0 : response.data.count
            this.search.currentPage = this.search.currentPage
            this.search.startRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : this.search.perpage * (this.search.currentPage - 1) + 1
            this.search.endRowNum = (response.data.count === undefined || response.data.count === 0) ? 0 : (this.search.perpage > response.data.count) ? response.data.count : (this.search.currentPage * this.search.perpage) >= response.data.count ? response.data.count : this.search.currentPage * this.search.perpage
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === "0006") {
            this.$parent.logOut(true, true);
          } else {
            this.items = [];
            miniToastr.error(response.data.message, "資料讀取異常");
            console.log(response.data.message);
          }
        })
        .catch(error => {
          this.items = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    querySelectListBrands() {
      //品牌下拉選單
      axios
        .post(API_URL + "/web/brands/v1", {
          all: false,
          order: true
        })
        .then(response => {
          this.selectListBrands = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListBrands = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    changePage (page) {
      this.search.currentPage = page
      this.query();
    },
    querySelectListData() {
      //支付工具
      axios
        .post(API_URL + "/web/getpayment/v1", {
          status: 0
        })
        .then(response => {
          this.paymenttypeList = response.data.data;
          this.$parent.Loading = false;
        })
        .catch(error => {
          this.selectListPosType = [];
          this.$parent.Loading = false;
          miniToastr.error(error, "資料讀取異常");
          console.log(error);
        });
    },
    setdate() {
      var d = new Date();
      var year = d.getFullYear();
      var mon =
      d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      this.search.edate = year+"/"+mon
      this.search.sdate = year+"/"+mon;
    },
    changePage(page) {
      this.search.currentPage = page;
      this.query();
    },
    nameWithLang ({ Name }) {
      return `${Name}`
    }
  },
  watch: {
    'search.queryBrandsCode'(selectedBrandCode) {
      if (selectedBrandCode) {
      this.storeList = []
      this.getpost()
      }
    }
  },
  filters: {
    formatDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      return year + "/" + mon + "/" + day;
    },
    formatFullDate: function(date) {
      var d = new Date(date);
      var year = d.getFullYear();
      var mon =
        d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
      var day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
      var hour = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
      var min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
      var sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
      return year + "/" + mon + "/" + day + " " + hour + ":" + min + ":" + sec;
    }
  }
};
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move > tbody > tr {
  cursor: move;
}
.block {
  text-align: center;
  height: 454pt;
}
.front_img {
  height: 450pt;
  position: relative;
  z-index: 1;
}
.bk_div {
  top: 53pt;
  left: 79pt;
  width: 196pt;
  height: 344pt;
  position: absolute;
  z-index: 0;
}
.bk_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/payment/List.vue